module.exports = __webpack_public_path__ + "img/mysql.b48571fe.svg";